import React from 'react';
import AppShell from '@/components/layout/AppShell';
import { adminNav } from '@/lib/navConfig';
import LeaderboardView from '@/components/leaderboard/LeaderboardView';

export default function AdminLeaderboard() {
  return <AppShell nav={adminNav} title="Leaderboard Sales"><LeaderboardView /></AppShell>;
}
